<template>
		<!--
		<div class="oneline d-flex mb-3" v-if="typeof $route.query.client_id != 'undefined' && typeof $route.query.taskend_id != 'undefined' && typeof $route.query.task_id != 'undefined' && masPotrebnosti.length>0">
		-->
		<div class="ReClientNeeds " v-if="masPotrebnosti.length>0">			
			<div class="mr-3 mb-1">
				<h6 class="mb-0">Потребности клиента: </h6>
			</div>
			<div class="">
				<div class="row-no-wrap" style="width: fit-content;">
					<p class="mb-0">{{masPotrebnosti.join(', ')}}</p>
					<base-button v-show="typeof objService !='undefined' && objService.editable==1" v-if="typeof objService !='undefined' && objService.STATUS!='На контроле' && objService.STATUS!='Сделка закрыта'"
						@click="GoToTaskEndEdit()" 
						type="primary"
						class="no-border my-0 ml-1"
						simple
						icon
					>
					<i class="d-inline-block tim-icons icon-pencil"></i>
					</base-button>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: 'ReClientNeeds',
		components: {

		},
		props: {
			objService: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				objGetParams: {},
				objPotrebnostiFields: {
					'all':['rooms','district_ids','metro_ids','fin_purchase'],
					'15':['rooms','district_ids','metro_ids','fin_purchase'],
				},
				service_obj: {},
			}
		},
		computed: {
			masPotrebnosti: function(){
				let masRet = [];
				let masFields = [];
				let service_obj = {};
				
				if(typeof this.objService == 'undefined'){
					service_obj = this.$GVO.unlinkObject(this.service_obj);
				}else{
					service_obj = this.$GVO.unlinkObject(this.objService);
				}
				if(Object.keys(this.objPotrebnostiFields).indexOf(service_obj.BP_ID) != -1){
					masFields = this.objPotrebnostiFields[service_obj.BP_ID];
				}else{
					masFields = this.objPotrebnostiFields['all'];
				}
				if(masFields.length>0){
					for (let i = 0; i < masFields.length; i++) {
						if(typeof service_obj[masFields[i]] != 'undefined' && service_obj[masFields[i]] != ''){
							if(this.getPotrebnostiNormValue(masFields[i],service_obj[masFields[i]]) != '')
								masRet.push(this.getPotrebnostiNormValue(masFields[i],service_obj[masFields[i]]));
						}
					}
				}
				
				return masRet;
			}
		},
		methods: {
			getPotrebnostiNormValue(valType,value){
				let masResult = [];
				switch (valType) {
					case 'rooms':
						masResult = this.getPotrebnostiCatNormValue(value.split(','),'CAT_ROOMS');
						break;
					case 'district_ids':
						masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_DIST','name_tr');
						break;
					case 'metro_ids':
						masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_METRO');
						break;
					case 'fin_purchase':
						if(parseFloat(value) > 0)
							masResult.push(this.$GVO.formatAmount(parseFloat(value)));
						break;
					default:
						break;
				}
				return masResult.join(', ');
			},
			getPotrebnostiCatNormValue(masData,cat_name,cat_key){
				let masResult = [];
				for (let i = 0; i < masData.length; i++) {
					if(masData[i] != ''){
						let v = this.$GVO.GetCatValName(cat_name,masData[i],cat_key);
						if(v != false){
							masResult.push(v);
						}else{
							masResult.push(masData[i]);
						}
					}						
				}
				return masResult;
			},
			GoToTaskEndEdit() {
				this.$GVO.ApiCall('GET_FORM_TASKEND_CHECKLISTIDS',{obj:'services',flt:{'service_id':this.objService.id}})
					.then((objApi) => {
						if(objApi.success === true && objApi.data.length>0){
							//console.log(objApi);
							this.$router.push({path: '/data/service/id/'+this.objService.id+'/task-end/id/'+objApi.data[0].taskend_id+'/edit?client_id='+objApi.data[0].client_id+'&task_id='+objApi.data[0].task_id});
						}else{
							//alert('Задачи "выявить потребности" ещё не было назначено');
							alert('Задача "Выявить потребности" ещё не выполнена');
						}
					}).catch(errorObjApi => console.error(errorObjApi));
			},
			GetServiceData(){
				this.$GVO.ApiCall('GET',{obj:'services',flt:{'client_id':this.$route.query.client_id,'id':this.$route.query.service_id}})
					.then((objApi) => {
						if(objApi.success === true && objApi.data.length>0){
							//console.log(objApi);
							this.service_obj = objApi.data[0];
						}
					}).catch(errorObjApi => console.error(errorObjApi));
			},
		},
		mounted(){
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.$route.query.client_id != 'undefined' && typeof this.$route.query.service_id != 'undefined' && typeof this.$route.query.task_id != 'undefined' && typeof this.objService == 'undefined'){
				this.GetServiceData();
			}
		}
	}
</script>
<style scoped>
	.row-no-wrap {display: flex; align-items: center;}
	.oneline > * {display: inline-block;}
	.oneline > h4 {padding-left: 0px;}
	.oneline .col-md-6 {padding-left: 0;}
	.ReClientNeeds {padding: 10px; border: 1px dashed #01B0E0; border-radius: 6px; width: fit-content;} 

</style>
